<template>
  <div class="title">
    <slot />
  </div>
</template>

<script>
export default { name: 'Title' };
</script>

<style lang="scss" scoped>
.title {
  text-transform: uppercase;

  :nth-child(1),
  :nth-child(3) {
    font-weight: lighter;
    &::before {
      content: '\a0';
      display: inline-block;
    }
  }
  :nth-child(2) {
    font-weight: bold;
  }
}
</style>
